import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment-timezone';

import EntityForm from '../../../common/components/containers/EntityForm';

import translatePropTypes from '../../../common/translatePropTypes';
import withTranslations from '../../../common/components/utils/Translations/withTranslations';
import TimeZonesField from '../../../common/components/containers/EntityForm/fields/TimeZonesField';
import WeekDayField from './fields/WeekDayField';

@withTranslations
export default class SitePreferencesForm extends React.PureComponent {
  static propTypes = {
    entity: PropTypes.shape({
      timezone: PropTypes.string.isRequired,
    }).isRequired,
    ...translatePropTypes,
  };

  timeZones = timeZones();

  render() {
    const { entity, onSubmit: handleSubmit, t } = this.props;

    return (
      <EntityForm
        columns={4}
        entity={entity}
        entityName="site-preferences"
        isNew={false}
        onSubmit={handleSubmit}
      >
        <TimeZonesField
          liveSearch
          required
          dataCy="site-preferences-timezone-field"
          label={t('Current Timezone')}
          name="timezone"
        />
        <WeekDayField required dataCy="site-preferences-week-start-field" />
      </EntityForm>
    );
  }
}

function timeZones() {
  const timeZones = moment.tz.names().map(zone => ({
    name: `(GMT ${moment.tz(zone).format('Z')}) ${zone}`,
    value: zone,
  }));

  return _.sortBy(timeZones, zone => moment.tz(zone.value).format('Z'));
}
